import { render } from "./EduRegisterPage.vue?vue&type=template&id=50b99d64&scoped=true"
import script from "./EduRegisterPage.vue?vue&type=script&lang=js"
export * from "./EduRegisterPage.vue?vue&type=script&lang=js"

import "./EduRegisterPage.vue?vue&type=style&index=0&id=50b99d64&scoped=true&lang=css"

import exportComponent from "D:\\workspace\\eduwind-front\\eduwind-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50b99d64"]])

export default __exports__